__turbopack_context__.v({
  "amenity-count": "style-module-scss-module__CYsNoa__amenity-count",
  "amenity-icon": "style-module-scss-module__CYsNoa__amenity-icon",
  "amenity-label": "style-module-scss-module__CYsNoa__amenity-label",
  "amenity-left": "style-module-scss-module__CYsNoa__amenity-left",
  "amenity-pill": "style-module-scss-module__CYsNoa__amenity-pill",
  "amenity-rows": "style-module-scss-module__CYsNoa__amenity-rows",
  "card": "style-module-scss-module__CYsNoa__card",
  "card-inner": "style-module-scss-module__CYsNoa__card-inner",
  "card-title": "style-module-scss-module__CYsNoa__card-title",
  "cards-track": "style-module-scss-module__CYsNoa__cards-track",
  "city-insights": "style-module-scss-module__CYsNoa__city-insights",
  "commute-scores": "style-module-scss-module__CYsNoa__commute-scores",
  "fade-in": "style-module-scss-module__CYsNoa__fade-in",
  "info-backdrop": "style-module-scss-module__CYsNoa__info-backdrop",
  "info-btn": "style-module-scss-module__CYsNoa__info-btn",
  "info-drawer-handle": "style-module-scss-module__CYsNoa__info-drawer-handle",
  "info-drawer-portal": "style-module-scss-module__CYsNoa__info-drawer-portal",
  "info-popup": "style-module-scss-module__CYsNoa__info-popup",
  "info-popup-body": "style-module-scss-module__CYsNoa__info-popup-body",
  "info-popup-close": "style-module-scss-module__CYsNoa__info-popup-close",
  "info-popup-disclaimer": "style-module-scss-module__CYsNoa__info-popup-disclaimer",
  "info-popup-header": "style-module-scss-module__CYsNoa__info-popup-header",
  "info-popup-sources": "style-module-scss-module__CYsNoa__info-popup-sources",
  "info-popup-title": "style-module-scss-module__CYsNoa__info-popup-title",
  "info-wrapper": "style-module-scss-module__CYsNoa__info-wrapper",
  "list-avatar": "style-module-scss-module__CYsNoa__list-avatar",
  "list-avatar-icon": "style-module-scss-module__CYsNoa__list-avatar-icon",
  "list-avatar-img": "style-module-scss-module__CYsNoa__list-avatar-img",
  "list-avatar-initial": "style-module-scss-module__CYsNoa__list-avatar-initial",
  "list-item": "style-module-scss-module__CYsNoa__list-item",
  "list-items": "style-module-scss-module__CYsNoa__list-items",
  "list-name": "style-module-scss-module__CYsNoa__list-name",
  "list-name-bold": "style-module-scss-module__CYsNoa__list-name-bold",
  "list-sub": "style-module-scss-module__CYsNoa__list-sub",
  "list-text": "style-module-scss-module__CYsNoa__list-text",
  "loading-lines": "style-module-scss-module__CYsNoa__loading-lines",
  "loading-row": "style-module-scss-module__CYsNoa__loading-row",
  "loading-rows": "style-module-scss-module__CYsNoa__loading-rows",
  "overview-body": "style-module-scss-module__CYsNoa__overview-body",
  "overview-card": "style-module-scss-module__CYsNoa__overview-card",
  "overview-desc": "style-module-scss-module__CYsNoa__overview-desc",
  "overview-tag": "style-module-scss-module__CYsNoa__overview-tag",
  "overview-tags": "style-module-scss-module__CYsNoa__overview-tags",
  "rating-denom": "style-module-scss-module__CYsNoa__rating-denom",
  "rating-text": "style-module-scss-module__CYsNoa__rating-text",
  "school-info": "style-module-scss-module__CYsNoa__school-info",
  "school-name": "style-module-scss-module__CYsNoa__school-name",
  "school-rating": "style-module-scss-module__CYsNoa__school-rating",
  "school-row": "style-module-scss-module__CYsNoa__school-row",
  "school-rows": "style-module-scss-module__CYsNoa__school-rows",
  "school-type": "style-module-scss-module__CYsNoa__school-type",
  "score-desc": "style-module-scss-module__CYsNoa__score-desc",
  "score-icon": "style-module-scss-module__CYsNoa__score-icon",
  "score-labels": "style-module-scss-module__CYsNoa__score-labels",
  "score-left": "style-module-scss-module__CYsNoa__score-left",
  "score-name": "style-module-scss-module__CYsNoa__score-name",
  "score-ring": "style-module-scss-module__CYsNoa__score-ring",
  "score-row": "style-module-scss-module__CYsNoa__score-row",
  "score-value": "style-module-scss-module__CYsNoa__score-value",
  "scroll-btn": "style-module-scss-module__CYsNoa__scroll-btn",
  "scroll-controls": "style-module-scss-module__CYsNoa__scroll-controls",
  "section-description": "style-module-scss-module__CYsNoa__section-description",
  "slide-up": "style-module-scss-module__CYsNoa__slide-up",
  "total-badge": "style-module-scss-module__CYsNoa__total-badge",
});
